module.exports = __webpack_public_path__ + "img/_request_solid.ad973100.svg";